import { render, staticRenderFns } from "./AddBike.vue?vue&type=template&id=484c30c7&scoped=true&lang=pug&"
import script from "./AddBike.vue?vue&type=script&lang=js&"
export * from "./AddBike.vue?vue&type=script&lang=js&"
import style0 from "./AddBike.vue?vue&type=style&index=0&id=484c30c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484c30c7",
  null
  
)

export default component.exports